import { VioletIcon } from '../DetailComponents/utils';

export const senHorizConfig = {
  id: 'sen_horiz',
  label: 'Señalética Horizontal',
  regex: /señal|horiz|linea|cebra|demarc|pintura|senda|peaton|flecha|símbolo|simbolo/,
  autoHeatmap: true,
  icon: VioletIcon,
  jsonFields: [
    { key: 'tipo_marca', label: 'Tipo de Marca' },
    { key: 'estado', label: 'Estado' },
    { key: 'material', label: 'Material' },
    { key: 'visible', label: 'Visible', type: 'bool' },
    { key: 'desgastada', label: 'Desgastada', type: 'bool' },
  ],
  subFilters: [
    { 
      id: 'lineas', 
      label: 'Líneas', 
      check: (m) => /linea|línea|borde|carril/.test((m.tipo || '') + (m.tipo_especifico || '')) 
    },
    { 
      id: 'simbolos', 
      label: 'Símbolos', 
      check: (m) => /flecha|símbolo|simbolo|pare|despacio/.test((m.tipo || '') + (m.tipo_especifico || '')) 
    },
    { 
      id: 'sendas', 
      label: 'Sendas', 
      check: (m) => /senda|peatonal|cebra/.test((m.tipo || '') + (m.tipo_especifico || '')) 
    }
  ],
  calculatePriority: () => 'Baja',
  calculateCompany: () => 'N/A',
  summaryConfig: {
    showCompanyKPI: false,
    showPriorityKPI: false,
    mainChart: 'sub-categories'
  },
  hasPriority: false,
  hasCompany: false,
  renderExtraInfo: () => null
};
